import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'landing-header',
  templateUrl: './landing-header.component.html',
})
export class LandingHeaderComponent implements OnInit {
  @Input() dynamicLogo: string = '';
  constructor() {}

  ngOnInit() {}

  encodeImageUrl(url: string): string {
    if (!url) return '';
    return url
      .replace(/ /g, '%20') // Spaces
      .replace(/\(/g, '%28') // Opening parentheses
      .replace(/\)/g, '%29') // Closing parentheses
      .replace(/\[/g, '%5B') // Opening brackets
      .replace(/\]/g, '%5D') // Closing brackets
      .replace(/"/g, '%22') // Double quotes
      .replace(/'/g, '%27') // Single quotes
      .replace(/,/g, '%2C') // Commas
      .replace(/;/g, '%3B') // Semicolons
      .replace(/=/g, '%3D') // Equals signs
      .replace(/&/g, '%26') // Ampersands
      .replace(/\+/g, '%2B') // Plus signs
      .replace(/#/g, '%23') // Hash symbols
      .replace(/\?/g, '%3F'); // Question marks
  }
}
